import events_mixin from "~/mixins/events"
import notif_action_mixin from "./notification/actions"

import messages from "./notification/messages"

export default {
  mixins: [events_mixin, notif_action_mixin],
  computed: {
    message: function () {
      const key = this.notification.kind
      const build = messages[key]

      if (typeof build === "function")
        return build(this.notification.context, this.$store.state.locale)
      else return ""
    },
    time: function () {
      const cmp = [60, 60, 24, 30, 12]
      const str = this.months
      const inc = new Date(this.notification.datetime_sent).getTime()
      var diff = new Date().getTime() - inc
      var index = 0

      diff /= 1000
      while (index < cmp.length && diff > cmp[index]) {
        diff /= cmp[index]
        index++
      }
      if (index >= cmp.length) return Math.floor(diff) + "y"
      else return Math.floor(diff).toString() + str[index]
    },
    hasArrayOfPicture: function () {
      return typeof this.notification.pictures === "object"
    },
    months: function () {
      if (this.$store.state.locale === "fr") return ["s", "m", "h", "j"]
      else return ["s", "m", "h", "d"]
    },
  },
  methods: {
    handleNotificationAction: function () {
      const fn = this[this.notification.context.action]

      this.trackEvent({
        category: "Notification",
        action: "used",
        kind: this.notification.kind,
        seen: this.notification.datetime_seen !== null,
      })
      this.$emit("mark_as_seen", [this.notification.id])
      if (typeof fn === "function")
        fn({
          notification: this.notification,
        })
    },
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
}
